export default "__VITE_ASSET__oEs92AOz__"